module.exports = __webpack_public_path__ + "static/media/Lato-BlackItalic.6c522f09.ttf";